import PropTypes from "prop-types"
import React from "react"
import IconTypeCell from "sheets/components/cells/IconTypeCell"

const { TransactionType, TransactionSpecialType } = DjangIO.app.ledger.types

const transactionIcons = [
    TransactionType.money_given.fa5_icon, // "minus"
    TransactionType.money_received.fa5_icon, // "plus"
]

const flipTransactionIcon = (iconName) =>
    transactionIcons[(transactionIcons.indexOf(iconName) + 1) % transactionIcons.length]
    || iconName

/**
 * Use IconTypeCell to represent a PAC transaction — receipt, disbursement,
 * receipt refund, disbursement refund, or a voided transaction.
 *
 * Icon is plus or minus, determined by djangio's TransactionType, but flipped
 * for voids, because void transactions have same TransactionType as the
 * transaction they refer to.
 * In other words, a Disbursement Void is a transaction with
 * type = disbursement and specialType = reversal.
 *
 * @param type number representing a TransactionType value
 * @param specialType number representing a TransactionSpecialType value, which
 * is Reversal for voids.
 */
const TransactionTypeCell = ({type, specialType}) => {
    const isVoid = specialType === TransactionSpecialType.reversal.value
    const typeEnum = type && TransactionType.by_value(type)
    const iconOverride = isVoid && typeEnum ? flipTransactionIcon(typeEnum.fa5_icon) : undefined
    return (
        <IconTypeCell
            value={type}
            djangioType={DjangIO.app.ledger.types.TransactionType}
            labelField="pac_label"
            iconOverride={iconOverride}
        >
            {isVoid && " Void"}
        </IconTypeCell>
    )
}

TransactionTypeCell.propTypes = {
    type: PropTypes.number.isRequired, // djangio TransactionType value
    specialType: PropTypes.number, // djangio TransactionSpecialType value
}

export default TransactionTypeCell
